import Button from "components/Button/Button";
import KaboodleModal from "components/Modals/KaboodleModal";

import "./EmailTypeSelectionModal.scss";

type EmailTypeSelectionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  showAcknowledgementEmail: boolean;
  showRatedAgeRequest: boolean;
  showRequestForMaterials: boolean;
  onSelectAcknowledgementEmail: () => void;
  onSelectRatedAgeRequest: () => void;
  onSelectRequestForMaterials: () => void;
};

// Ack email, rated age request, and request for materials share one mail
// icon in the sidebar; this picker lets the user say which one they want.
const EmailTypeSelectionModal = ({
  isOpen,
  onClose,
  showAcknowledgementEmail,
  showRatedAgeRequest,
  showRequestForMaterials,
  onSelectAcknowledgementEmail,
  onSelectRatedAgeRequest,
  onSelectRequestForMaterials,
}: EmailTypeSelectionModalProps) => {
  return (
    <KaboodleModal
      isOpen={isOpen}
      onClose={onClose}
      title="Email Correspondence"
    >
      <div className="flex jc-c email-type-options">
        {showAcknowledgementEmail && (
          <Button onClick={onSelectAcknowledgementEmail}>
            Acknowledgement Email
          </Button>
        )}
        {showRatedAgeRequest && (
          <Button onClick={onSelectRatedAgeRequest}>Rated Age Request</Button>
        )}
        {showRequestForMaterials && (
          <Button onClick={onSelectRequestForMaterials}>
            Request For Materials
          </Button>
        )}
      </div>
    </KaboodleModal>
  );
};

export default EmailTypeSelectionModal;
